import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";
import Fonctions from "constants/Fonctions";
import { elusUtil } from "utils";
import ElusListSkeleton from "components/Informations/Elus/ElusListSkeleton";
import EluLink from "components/Links/EluLink";
import { mandatsService } from "services";
import { useErrorHandler, withComponentErrorBoundary } from "utils/errorHandling";
import type { Mandat } from "models";

interface TerritoireInformationsGeneralesProps {
  territoireId: string;
}

function InnerTerritoireInformationsGenerales({
  territoireId,
}: Readonly<TerritoireInformationsGeneralesProps>): ReactNode {
  const [mandats, setMandats] = useState<Array<Mandat>>([]);
  const { catchErrors, isLoading } = useErrorHandler();

  useEffect(() => {
    void catchErrors(async () => {
      const _mandats = await mandatsService.getByFilter({
        territoiresIds: [territoireId],
        fonctionsIds: [
          Fonctions.PRESIDENT_TERRITOIRE,
          Fonctions.SUPPLEANT_PRESIDENT_TERRITOIRE,
          Fonctions.PRESIDENT_COMMISSION_MARCHES,
          Fonctions.SUPPLEANT_PRESIDENT_COMMISSION_MARCHES,
        ],
        isActive: true,
      });
      _mandats.sort(elusUtil.sortMandatsByImportance);
      setMandats(_mandats);
    });
  }, [territoireId, catchErrors]);

  if (isLoading) {
    return <ElusListSkeleton />;
  }

  return (
    <Grid container spacing={2} size={12}>
      {mandats.map((m) => (
        <Grid container key={m.id} size={12} spacing={0}>
          <Grid container size={12}>
            <Typography>{m.libelleFonction}</Typography>
          </Grid>
          <Grid container size={12}>
            <EluLink elu={elusUtil.getEluFromMandat(m)} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

const TerritoireInformationsGenerales = withComponentErrorBoundary(
  InnerTerritoireInformationsGenerales
);
export default TerritoireInformationsGenerales;
